export default __webpack_public_path__ + "static/media/info_round.a6002c38.svg";